import { Navigate } from 'react-router-dom';
import { MARKETING_AUDIENCES } from 'config/routes';

export default () => <Navigate to={MARKETING_AUDIENCES} replace />;
